import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Video, Play, Clock, Eye, BookOpen, Sparkles, X, ChevronRight } from "lucide-react";

const AfiliadoTutorials = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const tutorials = [
    {
      id: 1,
      title: "Click Hub Sistema - A Revolucao do Varejo Online",
      description: "Conheca o Click Hub Sistema e como ele revoluciona a integracao com marketplaces para vender mais",
      url: "https://www.youtube.com/watch?v=EnTKOjd9P2s",
      thumbnail: "https://img.youtube.com/vi/EnTKOjd9P2s/maxresdefault.jpg",
      category: "Integracoes",
      duration: "0:42",
      views: 150,
      level: "Iniciante"
    },
    {
      id: 2,
      title: "Apresentacao Click Hub - Filmagens e Drone",
      description: "Apresentacao da Agencia Click com filmagens aereas profissionais mostrando a estrutura do projeto",
      url: "https://www.youtube.com/watch?v=WJc0rcWYJog",
      thumbnail: "https://img.youtube.com/vi/WJc0rcWYJog/maxresdefault.jpg",
      category: "Apresentacao",
      duration: "3:40",
      views: 230,
      level: "Iniciante"
    },
    {
      id: 3,
      title: "Perfume Contratipo - As Emocoes Impactam Vidas",
      description: "Exemplo de produto sendo promovido atraves do sistema ClickHub com emocao e estrategia",
      url: "https://www.youtube.com/watch?v=paRCord4bN0",
      thumbnail: "https://img.youtube.com/vi/paRCord4bN0/maxresdefault.jpg",
      category: "Estrategia",
      duration: "0:22",
      views: 95,
      level: "Iniciante"
    },
    {
      id: 4,
      title: "Maximize seus lucros com Dropshipping",
      description: "Click Hub simplifica a gestao do dropshipping para voce focar no que importa: vender!",
      url: "https://www.youtube.com/shorts/cUWFY5zxLzs",
      thumbnail: "https://img.youtube.com/vi/cUWFY5zxLzs/maxresdefault.jpg",
      category: "Estrategia",
      duration: "0:30",
      views: 80,
      level: "Iniciante"
    },
    {
      id: 5,
      title: "Expandindo Fronteiras com Multiplos Marketplaces",
      description: "Conectado a multiplos marketplaces com Click Hub para expandir seu dropshipping",
      url: "https://www.youtube.com/shorts/D_jEPpPnO90",
      thumbnail: "https://img.youtube.com/vi/D_jEPpPnO90/maxresdefault.jpg",
      category: "Integracoes",
      duration: "0:25",
      views: 4,
      level: "Iniciante"
    },
    {
      id: 6,
      title: "Como Conectar Mercado Livre no ClickHub",
      description: "Tutorial passo a passo para conectar sua conta do Mercado Livre via OAuth no sistema",
      url: "https://www.youtube.com/watch?v=EnTKOjd9P2s",
      thumbnail: "https://img.youtube.com/vi/EnTKOjd9P2s/hqdefault.jpg",
      category: "Integracoes",
      duration: "0:42",
      views: 150,
      level: "Intermediario"
    },
    {
      id: 7,
      title: "Usando a IA para Criar Anuncios",
      description: "Aprenda a usar o gerador de anuncios com IA para criar titulos e descricoes que vendem",
      url: "https://www.youtube.com/watch?v=EnTKOjd9P2s",
      thumbnail: "https://img.youtube.com/vi/EnTKOjd9P2s/hqdefault.jpg",
      category: "IA e Automacao",
      duration: "0:42",
      views: 200,
      level: "Intermediario"
    },
    {
      id: 8,
      title: "Primeiros Passos com o ClickHub",
      description: "Guia completo para comecar a vender nos marketplaces usando o ClickHub Sistema",
      url: "https://www.youtube.com/watch?v=EnTKOjd9P2s",
      thumbnail: "https://img.youtube.com/vi/EnTKOjd9P2s/hqdefault.jpg",
      category: "Apresentacao",
      duration: "0:42",
      views: 300,
      level: "Iniciante"
    }
  ];

  const categories = ["Todos", "Integracoes", "Apresentacao", "Estrategia", "IA e Automacao"];
  const [selectedCategory, setSelectedCategory] = useState("Todos");

  const filteredTutorials = selectedCategory === "Todos" 
    ? tutorials 
    : tutorials.filter(t => t.category === selectedCategory);

  const getYouTubeEmbedUrl = (url) => {
    const videoId = url.split("v=")[1]?.split("&")[0] || url.split("/").pop();
    return `https://www.youtube.com/embed/${videoId}`;
  };

  const getLevelColor = (level) => {
    switch(level) {
      case "Iniciante": return "bg-green-500/20 text-green-400";
      case "Intermediário": return "bg-yellow-500/20 text-yellow-400";
      case "Avançado": return "bg-red-500/20 text-red-400";
      default: return "bg-gray-500/20 text-gray-400";
    }
  };

  return (
    <div className="flex flex-col h-full bg-gray-950">
      {/* Header Fixo */}
      <div className="p-4 lg:p-6 border-b border-gray-800">
        <div className="flex items-center gap-2 mb-1">
          <span className="bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs font-bold px-2 py-1 rounded-full uppercase">Tutoriais</span>
          <h1 className="text-xl font-bold text-white">Central de Aprendizado</h1>
        </div>
        <p className="text-sm text-gray-400">Aprenda tudo sobre o sistema com nossos vídeos tutoriais</p>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
          <Card className="bg-gradient-to-br from-blue-500 to-blue-600 p-3 border-none">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-white/80 text-xs mb-1">Total Tutoriais</p>
                <p className="text-white text-2xl font-bold">{tutorials.length}</p>
              </div>
              <Video className="w-6 h-6 text-white/80" />
            </div>
          </Card>

          <Card className="bg-gradient-to-br from-purple-500 to-purple-600 p-3 border-none">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-white/80 text-xs mb-1">Horas Conteúdo</p>
                <p className="text-white text-2xl font-bold">1h 20m</p>
              </div>
              <Clock className="w-6 h-6 text-white/80" />
            </div>
          </Card>

          <Card className="bg-gradient-to-br from-green-500 to-green-600 p-3 border-none">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-white/80 text-xs mb-1">Total Views</p>
                <p className="text-white text-2xl font-bold">11.4k</p>
              </div>
              <Eye className="w-6 h-6 text-white/80" />
            </div>
          </Card>

          <Card className="bg-gradient-to-br from-orange-500 to-orange-600 p-3 border-none">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-white/80 text-xs mb-1">Categorias</p>
                <p className="text-white text-2xl font-bold">{categories.length - 1}</p>
              </div>
              <BookOpen className="w-6 h-6 text-white/80" />
            </div>
          </Card>
        </div>

        {/* Filtros */}
        <div className="mt-4 flex flex-wrap gap-2">
          {categories.map((cat) => (
            <Button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              size="sm"
              className={`h-8 ${selectedCategory === cat 
                ? "bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600" 
                : "bg-gray-700 hover:bg-gray-600"
              }`}
            >
              {cat}
            </Button>
          ))}
        </div>
      </div>

      {/* Conteúdo com Scroll */}
      <div className="flex-1 p-4 lg:p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pb-4">
          {filteredTutorials.map((tutorial) => (
            <Card 
              key={tutorial.id} 
              className="bg-gray-800/50 border-gray-700 overflow-hidden hover:border-purple-500 transition-all cursor-pointer group"
              onClick={() => setSelectedVideo(tutorial)}
            >
              {/* Thumbnail */}
              <div className="relative h-36 bg-gray-900 overflow-hidden">
                <img 
                  src={tutorial.thumbnail} 
                  alt={tutorial.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  onError={(e) => {
                    e.target.src = "/images/clickhub-logo.png";
                  }}
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center">
                    <Play className="w-6 h-6 text-white ml-0.5" />
                  </div>
                </div>
                
                {/* Duration Badge */}
                <div className="absolute bottom-2 right-2 bg-black/80 px-2 py-0.5 rounded text-xs text-white font-semibold">
                  {tutorial.duration}
                </div>
              </div>

              {/* Content */}
              <div className="p-3">
                {/* Badges */}
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-purple-500/20 text-purple-400">
                    {tutorial.category}
                  </span>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${getLevelColor(tutorial.level)}`}>
                    {tutorial.level}
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-sm font-bold text-white mb-1 line-clamp-2 group-hover:text-purple-400 transition-colors">
                  {tutorial.title}
                </h3>

                {/* Description */}
                <p className="text-gray-400 text-xs mb-3 line-clamp-2">
                  {tutorial.description}
                </p>

                {/* Stats */}
                <div className="flex items-center justify-between text-xs text-gray-500">
                  <span className="flex items-center gap-1">
                    <Eye className="w-3 h-3" />
                    {tutorial.views.toLocaleString('pt-BR')}
                  </span>
                  <Button
                    size="sm"
                    className="bg-purple-500 hover:bg-purple-600 text-white h-7 text-xs"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedVideo(tutorial);
                    }}
                  >
                    <Play className="w-3 h-3 mr-1" />
                    Assistir
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Help Section */}
        <div className="mt-4 p-4 bg-gradient-to-r from-purple-500/10 to-pink-500/10 border border-purple-500/30 rounded-xl">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center flex-shrink-0">
              <Sparkles className="w-5 h-5 text-white" />
            </div>
            <div className="flex-1">
              <h3 className="text-base font-bold text-white mb-1">
                Precisa de Ajuda?
              </h3>
              <p className="text-gray-300 text-sm mb-3">
                Não encontrou o que procurava? Nossa equipe está pronta para ajudar!
              </p>
              <Button size="sm" className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 h-8">
                💬 Falar com Suporte
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Video Player Modal */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center overflow-y-auto py-8 z-50 p-4">
          <div className="max-w-4xl w-full">
            <Card className="bg-gray-900 border-gray-700">
              <div className="p-4">
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h2 className="text-lg font-bold text-white mb-1">{selectedVideo.title}</h2>
                    <p className="text-gray-400 text-sm">{selectedVideo.description}</p>
                  </div>
                  <Button
                    variant="ghost"
                    onClick={() => setSelectedVideo(null)}
                    className="text-gray-400 hover:text-white h-8 w-8 p-0"
                  >
                    <X className="w-5 h-5" />
                  </Button>
                </div>

                {/* Video Player */}
                <div className="aspect-video bg-black rounded-lg overflow-hidden mb-3">
                  <iframe
                    src={getYouTubeEmbedUrl(selectedVideo.url)}
                    className="w-full h-full"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>

                {/* Video Info */}
                <div className="flex items-center gap-4 text-sm text-gray-400">
                  <span className="flex items-center gap-1">
                    <Clock className="w-4 h-4" />
                    {selectedVideo.duration}
                  </span>
                  <span className="flex items-center gap-1">
                    <Eye className="w-4 h-4" />
                    {selectedVideo.views.toLocaleString('pt-BR')} views
                  </span>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${getLevelColor(selectedVideo.level)}`}>
                    {selectedVideo.level}
                  </span>
                </div>
              </div>
            </Card>
          </div>
        </div>
      )}
    </div>
  );
};

export default AfiliadoTutorials;
